import {combineReducers} from 'helpers';
import {index} from './index';
import {listItems} from './listItems';

export const lists = combineReducers({ index, listItems });
